import { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

// globals
import * as TYPE from '../globals/type'

axios.defaults.withCredentials = true

export const useAxios = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [data, setData] = useState(null)
  const [orderData, setOrderData] = useState(null)
  const [isStatChart, setIsStatChart] = useState(false)

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [alertMsg, setAlertMsg] = useState('')

  // 세션 만료 체크
  const [isSessionExpired, setIsSessionExpired] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    if (alertMsg !== '') {
      alert(alertMsg)

      setTimeout(() => {
        setAlertMsg('')
      }, 0)
    }
  }, [alertMsg])

  // 세션 만료시 에러
  const handleSessionExpired = (flag) => {
    if (!isSessionExpired) {
      //session alert count 확인
      if (parseInt(localStorage.getItem('sessionAlert')) < 1) {
        setAlertMsg(
          flag === 0
            ? '로그인이 필요합니다.'
            : '다른 PC에서 로그인한 사용자가 있어 자동로그아웃 처리됩니다.',
        )
        setIsSessionExpired(true) // true 변경하여 중복처리 제거
      }
      //session alert count업데이트 (alert 중복처리)
      let count = localStorage.getItem('sessionAlert')
      let localStorageCount = parseInt(count)
      const newCount = localStorageCount + 1
      localStorage.setItem('sessionAlert', newCount.toString())

      localStorage.removeItem('user')
      localStorage.removeItem('isNewNotice')
      localStorage.removeItem('happyorderYn')
      localStorage.removeItem('closedDay')
      localStorage.removeItem('shopHoursStart')
      localStorage.removeItem('shopHoursEnd')
      localStorage.removeItem('sessionAlert')

      window.location.reload()
      setLoading(false)
    }
  }

  const fetchData = async (url, method, requestBody, params, headers) => {
    try {
      setLoading(true)
      let requestHeaders = { 'Content-Type': 'application/json' }

      const response = await axios({
        method,
        url,
        headers: requestHeaders,
        data: requestBody,
        params: {
          ...params,
          userId: user?.userId.replace(/[^a-zA-Z0-9]/g, '') ?? '',
        },
        //   params: {
        //     ...params,
        //     userId: 'EXAG0003####'.replace(/[^a-zA-Z0-9]/g, '') ?? '',
        //   },
      })

      if (
        response.data.resultCode == '1003' ||
        response.data?.responseCode == TYPE.API_RESPONSE.NOT_DATA ||
        response.data.errorCode == '9998'
        // 통계 차트 제외
      ) {
        if (!response?.config?.params.hasOwnProperty('orderIncludeCancel')) {
          setIsStatChart(false)
          setAlertMsg('조회한 데이터가 없습니다.')
        } else {
          setIsStatChart(true)
        }

        setLoading(false)
      }

      if (response.data?.responseCode == TYPE.API_RESPONSE.FAILURE) {
        if (
          !window.location.pathname.includes('signin') &&
          !window.location.pathname.includes('findid') &&
          !window.location.pathname.includes('resetPassword') &&
          !window.location.pathname.includes('changePassword')
        ) {
          setAlertMsg('조회에 실패하였습니다.')
        }
        setLoading(false)
      }

      if (response.status == 200) {
        if (response.data != null || undefined) {
          setData(response.data)
          setOrderData(response.data)
          setLoading(false)
        } else {
          //response 데이터가 없을때
          // alert('입력된 데이터 없습니다.')
          setAlertMsg('입력된 데이터 없습니다.')
        }
        setLoading(false)
        setError(null)
      } else {
        // alert('입력된 데이터 없습니다.')
        setAlertMsg('입력된 데이터 없습니다.')
      }
      setLoading(false)
    } catch (error) {
      setError(error)
      setLoading(false)

      // 400에러시 에러페이지로 이동
      if (error?.response?.status == TYPE.API_RESPONSE.BAD_REQUEST) {
        navigate('/error')
      }

      // 세션 만료
      if (error?.response?.status == TYPE.API_RESPONSE.FORBIDDEN) {
        // 중복
        if (
          error?.response?.data?.responseCode === TYPE.API_RESPONSE.DUPLICATE
        ) {
          handleSessionExpired(1)
        }
        // 시간
        else {
          handleSessionExpired(0)
        }
      }

      // // 세션 만료(중복 로그인 O)
      // if (error?.response?.status == TYPE.API_RESPONSE.DUPLICATE) {
      //   handleSessionExpired(1)
      // }

      // if (error?.response?.status == 500 || error?.response?.status == 502) {
      //   setAlertMsg('네트워크 환경이 원활하지 않습니다. 다시 시도해주세요.')
      // }
      if (error?.response?.status.toString().startsWith('50')) {
        navigate('/error')
      }
    }
  }

  return { orderData, data, loading, error, fetchData, isStatChart }
}
